/**
 * Keeps the Dixa chat launcher clear of the sticky add-to-cart bar.
 *
 * The bar (.sticky-atc) is position:fixed at bottom:0 and slides in with
 * .is-visible once the main buy button scrolls out of view — which puts it
 * underneath Dixa's own fixed launcher. This lifts the launcher by the bar's
 * height while the bar is showing, and puts it back when the bar slides away.
 *
 * Dixa's markup is owned by their bootstrap script, so the launcher is found by
 * shape (a fixed-position element carrying "dixa" in its id/class, or the fixed
 * ancestor of a Dixa iframe) rather than by a hard-coded selector, and the DOM is
 * observed because the widget mounts asynchronously.
 */
(function () {
  var GAP = 12; // breathing room between launcher and bar
  var bar = null;
  var known = new Map(); // element -> original inline bottom value

  function findBar() {
    return document.querySelector('.sticky-atc');
  }

  function fixedAncestor(el) {
    while (el && el !== document.body) {
      if (getComputedStyle(el).position === 'fixed') return el;
      el = el.parentElement;
    }
    return null;
  }

  function launchers() {
    var found = new Set();

    document.querySelectorAll('[id*="dixa" i], [class*="dixa" i]').forEach(function (el) {
      if (getComputedStyle(el).position === 'fixed') found.add(el);
    });

    document.querySelectorAll('iframe[src*="dixa"]').forEach(function (frame) {
      var host = fixedAncestor(frame);
      if (host) found.add(host);
    });

    return found;
  }

  function apply() {
    if (!bar) bar = findBar();

    var showing = !!(bar && bar.classList.contains('is-visible'));
    var lift = showing ? Math.round(bar.getBoundingClientRect().height) + GAP : 0;

    launchers().forEach(function (el) {
      if (!known.has(el)) {
        known.set(el, el.style.bottom || '');
        // Match the bar's own slide so the two move together.
        el.style.transition = 'bottom 0.28s ease';
      }
      if (lift) {
        el.style.setProperty('bottom', lift + 'px', 'important');
      } else {
        var original = known.get(el);
        if (original) el.style.setProperty('bottom', original);
        else el.style.removeProperty('bottom');
      }
    });
  }

  function start() {
    bar = findBar();
    if (!bar) return; // not a product page with the sticky bar

    // The bar toggles .is-visible; the widget mounts (and remounts) on its own.
    new MutationObserver(apply).observe(bar, {
      attributes: true,
      attributeFilter: ['class'],
    });
    new MutationObserver(apply).observe(document.body, {
      childList: true,
      subtree: true,
    });
    window.addEventListener('resize', apply, { passive: true });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
